















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Dayjs } from 'dayjs';

@Component
export default class UnitClosingDatesInfo extends Vue {
  @Prop({ type: Object, required: true }) private unit!: {
    openedDate: Dayjs | string | null;
    closedDate: Dayjs | string | null;
  };
  @Prop({ type: [ Object, String ], required: true }) private date!: Dayjs  | string;

  private get willCompanyBeOpenedSoon(): boolean {
    if (!this.unit.openedDate) return false;

    return this.$dayjs.strict(this.date)
      .isBetween(
        this.$dayjs.strict(this.unit.openedDate).subtract(30, 'days'),
        this.unit.openedDate,
        'dates',
        '[)',
      );
  }

  private get willCompanyBeClosedSoon(): boolean {
    if (!this.unit.closedDate) return false;

    return this.$dayjs.strict(this.date)
      .isBetween(
        this.$dayjs.strict(this.unit.closedDate).subtract(30, 'days'),
        this.unit.closedDate,
        'dates',
        '[)',
      );
  }

  private get wasClosedRecently(): boolean {
    if (!this.unit.closedDate) return false;

    return this.$dayjs.strict(this.date)
      .isBetween(
        this.unit.closedDate,
        this.$dayjs.strict(this.unit.closedDate).add(30, 'days'),
        'dates',
        '[]',
      );
  }
}
